export class TemplateStore {
    constructor(templateConfig) {
        this._templateImport = templateConfig;
    }
    async initialize() {
        await this.getTemplateConfiguration();
    }
    get appConfigSource() {
        return this.templateConfiguration?.appConfigSource || 'files';
    }
    get externalScriptsBasePath() {
        return this.templateConfiguration?.externalScriptsBasePath;
    }
    get appScriptsBasePath() {
        return this.templateConfiguration?.appScriptsBasePath;
    }
    get cacheOptions() {
        return this.templateConfiguration?.cacheOptions;
    }
    async getTemplateConfiguration() {
        try {
            this.templateConfiguration = await this._templateImport;
            // this.templateConfiguration = await import('../../../configuration/templateConfig.json');
        }
        catch (ex) {
            console.error(`ERROR: getTemplateConfiguration: ${ex}`);
        }
    }
}
//# sourceMappingURL=TemplateStore.js.map